/** Espelha public.tipo_campo (db_compras) e `TipoCampoEnum` da API Compras. */
export enum TipoCampoEnum {
  Texto = 1,
  Numero = 2,
  Moeda = 3,
  Data = 4,
  Selecao = 5,
  SelecaoMultipla = 6,
  Vinculo = 7,
  SimNao = 9,
}
